// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proTitle {
  width: 1200px;
  margin: 0px auto;
  text-align: center;
  padding-top: 60px;
  padding-bottom: 40px;
}
.proTitle h3 {
  font-size: 30px;
  padding-bottom: 10px;
  margin: 0px;
}
.proTitle-text {
  color: #666;
  font-size: 16px;
  line-height: 30px;
  padding: 0px 100px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProTitle/index.less"],"names":[],"mappings":"AAAA;EAAU,aAAA;EAAc,gBAAA;EAAiB,kBAAA;EAAoB,iBAAA;EAAkB,oBAAA;AAM/E;AANA;EACM,eAAA;EAAgB,oBAAA;EAAqB,WAAA;AAU3C;AATG;EAAO,WAAA;EAAY,eAAA;EAAgB,iBAAA;EAAmB,kBAAA;AAezD","sourcesContent":[".proTitle{width:1200px; margin:0px auto; text-align: center; padding-top:60px; padding-bottom:40px;\n   h3{font-size:30px; padding-bottom:10px; margin: 0px;}\n   &-text{color:#666; font-size:16px; line-height: 30px; padding:0px 100px;}\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
